import React from 'react';
import { MainLayoutHeader, MainLayoutHeaderProps } from '@app/components';

export const PackHeader = ({ children }: Pick<MainLayoutHeaderProps, 'children'>) => {
  return (
    <MainLayoutHeader
      tabs={[
        {
          label: 'Menus',
          screenName: 'PackScreen',
          permissions: ['dashboard::packs.read'],
        },
        {
          label: 'Etapes',
          screenName: 'StepScreen',
          permissions: ['dashboard::steps.read'],
        },
      ]}>
      {children}
    </MainLayoutHeader>
  );
};
